<div class="body">

    <div class="afiliado" *ngIf="rol == 'ROLE_AFILIADO' && this.solicitud =='prestamo' ">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-5">
                    <h1> Consulta de Préstamos Disponibles</h1>
                </div>

                <div class="col-lg-4"> </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                    
                    <select class="form-control" (change)="buscar()" [(ngModel)]="config.itemsPerPage">

                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option> 
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div>
            <div class="row">
                <div class="col-lg-9">
                    <h1> </h1>
                </div>
                <div class="col-lg-2">

                    <button class="mat-raised-button btn-success" (click)="cargaSolicitudesCodeudor()">
        
                 Ver Solicitudes de Codeudor</button>

                </div>
            </div>
            <br/>

            <div class="table-responsive">

                <table class="table" style="border: 1px;">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th style="text-align: center;"> N° </th>
                            <th style="text-align: center;">RUT Solicitante</th>
                            <th style="text-align: center;">Nombre Solicitante</th>
                            <th style="text-align: center;"> Fecha Ingreso </th>
                            <th style="text-align: center;"> Producto </th>
                            <th style="text-align: center;"> Monto Solicitado </th>
                            <th style="text-align: center;"> Cantidad de Cuotas </th>
                            <th style="text-align: center;"> Fecha Primer Descuento</th>
                            <th style="text-align: center;"> RUT Codeudor 1</th>
                            <th style="text-align: center;"> Nombre Codeudor 1</th>
                            <th style="text-align: center;"> RUT Codeudor 2</th>
                            <th style="text-align: center;"> Nombre Codeudor 2</th>
                            <th style="text-align: center;"> Estado </th>
                            <th style="text-align: center;"> Motivo Rechazo </th>
                            <th style="text-align: center;"> Ver Archivo(s) </th>
                            <th style="text-align: center;"> Anular</th>

                        </tr>

                    </thead>

                    <tbody>
                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let pre of prestamos | paginate: config; let i = index">
                            <td style="text-align: center;">{{pre.idPostulacion}}</td>
                            <td style="text-align: center;">{{pre.rutUsuario}}</td>
                            <td style="text-align: center;">{{pre.nombreUsuario}} {{pre.apellidoUsuario}}</td>
                            <td style="text-align: center;">{{pre.fechaIngreso}}</td>
                            <td style="text-align: center;">{{pre.tipoPrestamoString}}</td>
                            <td style="text-align: center;">{{pre.montoSolicitado}}</td>
                            <td style="text-align: center;">{{pre.idCantidadCuota}}</td>
                            <td style="text-align: center;">{{pre.fechaPrimerPago}}</td>
                            <td style="text-align: center;">{{pre.rutCodeudorUno}}</td>
                            <td style="text-align: center;">{{pre.nombreCodeudorUno}} {{pre.apellidoCodeudorUno}}</td>
                            <td style="text-align: center;">{{pre.rutCodeudorDos}}</td>
                            <td style="text-align: center;">{{pre.nombreCodeudorDos}} {{pre.apellidoCodeudorDos}}</td>            
                            <td style="text-align: center;" *ngIf="pre.estado == 'PAGADA'"> <a (click)="detalleSolicitudPagada(pre.idPostulacion)" style="cursor:pointer; text-decoration: underline;">{{pre.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="pre.estado == 'CERRADA PAGADA'"> <a (click)="detalleSolicitudPagada(pre.idPostulacion)" style="cursor:pointer; text-decoration: underline;">{{pre.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="pre.estado != 'CERRADA PAGADA' && pre.estado != 'PAGADA'"> {{pre.estado}}</td>
                         
                            <td style="text-align: center;">{{pre.motivoRechazo}}</td>

                            <td style="text-align: center;"> <button class="btn btn-info" (click)="verArchivo(pre.idPostulacion)" style="width: 120px">

                                <i class = "fa fa-search"> </i> Ver

                            </button>
                            </td>             
                            <td *ngIf="pre.estado == 'PENDIENTE' || pre.estado == 'INGRESADA'" style="text-align: center;"> <button style="width: 120px" class="btn btn-danger" (click)="openDialogAnular(pre.idPostulacion, pre.rutUsuario)"> <!--*ngIf="pre.estado == 'INGRESADA' "-->

                                <i class = "fa fa-trash"> </i> Anular

                            </button> </td>
                            


                        </tr>

                    </tbody>

                </table> <br/>
                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>
            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>
    <div class="afiliado" *ngIf="rol == 'ROLE_AFILIADO' && this.solicitud =='codeudor' ">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-5">
                    <h1> Consulta de Solicitudes Codeudor</h1>
                </div>

                <div class="col-lg-4"> </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                  
                    <select class="form-control" (change)="buscar()" [(ngModel)]="config.itemsPerPage">
                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option> 
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div>
            <div class="row">
                <div class="col-lg-9">
                    <h1> </h1>
                </div>
                <div class="col-lg-2">

                    <button class="mat-raised-button btn-success" (click)="cargaSolicitudesDisponibles()">
        
                 Ver Solicitudes Disponibles</button>

                </div>
            </div>
            <br/>

            <div class="table-responsive">

                <table class="table" style="border: 1px;">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th style="text-align: center;"> N° </th>
                            <th style="text-align: center;"> RUT Solicitante</th>
                            <th style="text-align: center;"> Nombre Solicitante</th>
                            <th style="text-align: center;"> Fecha Ingreso </th>
                            <th style="text-align: center;"> Producto </th>
                            <th style="text-align: center;"> Monto Solicitado </th>
                            <th style="text-align: center;"> Cantidad de Cuotas </th>
                            <th style="text-align: center;"> Fecha Primer Descuento</th>
                            <th style="text-align: center;"> Estado Postulación</th>

                            <th style="text-align: center;"> Ver Archivo(s) </th>
                            <th style="text-align: center;"> Revisar</th>

                        </tr>

                    </thead>

                    <tbody>
                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let pre of prestamos | paginate: config; let i = index">
                            <td style="text-align: center;">{{pre.idPostulacion}}</td>
                            <td style="text-align: center;">{{pre.rutUsuario}}</td>
                            <td style="text-align: center;">{{pre.nombreUsuario}} {{pre.apellidoUsuario}}</td>
                            <td style="text-align: center;">{{pre.fechaIngreso}}</td>
                            <td style="text-align: center;">{{pre.tipoPrestamoString}}</td>
                            <td style="text-align: center;">{{pre.montoSolicitado}}</td>
                            <td style="text-align: center;">{{pre.idCantidadCuota}}</td>
                            <td style="text-align: center;">{{pre.fechaPrimerPago}}</td>
                            <td style="text-align: center;">{{pre.estado}}</td>
                            <td style="text-align: center;"> <button class="btn btn-info" (click)="verArchivo(pre.idPostulacion)" style="width: 120px">

                                <i class = "fa fa-search"> </i> Ver

                            </button>
                            </td>

                            <td style="text-align: center;" *ngIf="pre.idCodeudorUno == idEjecutivo && (pre.estado !='PENDIENTE')">

                                <p><button class=" btn-warning" (click)="openDialogCodeudorPrestamo(pre.idPostulacion,false)">
                                        <i class = "fa fa-pen"> </i> Revisar</button></p>

                            </td>

                            <td style="text-align: center;" *ngIf="pre.estado == 'PENDIENTE' && ( (pre.idCodeudorDos == idEjecutivo && pre.estadoCodeudorDos =='INGRESADA') || (pre.idCodeudorUno == idEjecutivo && pre.estadoCodeudorUno =='INGRESADA'))">
                                <p><button class="btn-success" (click)="openDialogCodeudorPrestamo(pre.idPostulacion,true)">
                                    <i class = "fa fa-money-bill-alt"> </i> Aceptar/Rechazar</button></p>
                            </td>
                        </tr>


                    </tbody>
                </table> <br/>

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>
            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>
    <div class="afiliado" *ngIf="rol != 'ROLE_AFILIADO' && this.solicitud =='prestamo' ">


        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; max-width: 1290px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-4">
                    <h1> Solicitud de Préstamos {{tipoPostulacion}} </h1>
                </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Asignadas'">

                    <button class="btn btn-info" (click)="postulacionesDisponiblesBuscador(true)"> Solicitudes Disponibles </button>
                </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Disponibles'">

                    <button class="btn btn-info" (click)="postulacionesAsignadas(true)"> Solicitudes Asignadas </button>

                </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">
                    <select class="form-control" (change)="buscar()" [(ngModel)]="buscador.itemsPerPage">
                   
                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div>
            <hr/> <br/>

            <div>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> RUT de Usuario: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="rut" class="form-control" type="text" #rut="ngModel" [(ngModel)]="buscador.rut" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>
                    <div class="col-lg-2" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' || this.rol == 'ROLE_CONTABILIDAD'  || this.rol == 'ROLE_ASISTENTE_SOCIAL'"> 
                        <h3> Región: </h3>
                    </div>

                    <div class="col-lg-3" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' || this.rol == 'ROLE_CONTABILIDAD'  || this.rol == 'ROLE_ASISTENTE_SOCIAL'">

                        <mat-select [(ngModel)]="buscador.region" [disabled]="this.rol != 'ROLE_ADMINISTRADOR' && this.rol != 'ROLE_ENCARGADO_NACIONAL' && this.rol != 'ROLE_COORDINADOR' && this.rol != 'ROLE_ENCARGADO_CONTABILIDAD' && this.rol != 'ROLE_CONTABILIDAD' && this.rol != 'ROLE_ASISTENTE_SOCIAL'">

                            <mat-option value="0">

                                SELECCIONE....

                            </mat-option>

                            <mat-option *ngFor="let region of regiones" value="{{region.id}}">

                                {{region.nombre}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> ID Solicitud: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input [(ngModel)]="buscador.idSolicitud" #idSolicitud="ngModel" class="form-control" type="number" pattern="[0-9]" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Estados: </h3>
                    </div>

                    <div class="col-lg-3">

                        <mat-select [(ngModel)]="buscador.estadoselect" multiple>

                            <mat-option *ngFor="let esta of estado" value="{{esta}}">

                                {{esta}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>


                <div class="row">

                    <div class="col-lg-2">
                        <h3> Fecha Inicio: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="fechaInicio" class="form-control" type="date" #fechaInicio="ngModel" [(ngModel)]="buscador.fechaInicio" placeholder="Ingrese la fecha Inicio" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Fecha Fin: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="fechaFin" class="form-control" type="date" #fechaFin="ngModel" [(ngModel)]="buscador.fechaFin" placeholder="Ingrese la fecha Fin" />

                    </div>

                    <div class="col-lg-2"> <button class="btn btn-info" (click)="buscar()">

                        <i class = "fa fa-search"></i> Buscar </button>

                    </div>

                </div>
                <hr/> <br/>

                <div class="row" *ngIf="tipoPostulacion == 'Disponibles'">

                    <div class="col-lg-2">
                        <h3>
                            <mat-checkbox color="primary" [checked]="allComplete" [indeterminate]="someComplete()" (change)="setAll($event.checked)"> Seleccionar Todo </mat-checkbox>
                        </h3>
                    </div>                  
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'  && rol != 'ROLE_ENCARGADO_NACIONAL' && rol != 'ROLE_ENCARGADO_REGIONAL' && rol != 'ROLE_ENCARGADO_REGIONAL_CONTABLE' 
                    && rol != 'ROLE_ENCARGADO_CONTABILIDAD' && rol != 'ROLE_CONTABILIDAD' && rol != 'ROLE_EJECUTIVO'">
              
                        <div class="col-lg-2"> <button mat-button class="mat-raised-button btn-warning" (click)="asignarSeleccionados()">

                                <i class = "fa fa-pen"></i> Asignar Seleccionados</button>
                        </div>
                    </div>
                    <div class="col-lg-5"> </div>
                    <div class="col-lg-2">



                    </div>

                </div>


            </div>
            <div class="row">
                <div class="col-lg-9">
                    <h1> </h1>
                </div>
                <div class="col-lg-2">


                </div>
            </div>
            <br/>

            <div class="table-responsive">

                <table class="table" style="max-width: 1290px;">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th> </th>

                            <th style="text-align: center;"> N° </th>
                            <th style="text-align: center;"> Rut Solicitante </th>
                            <th style="text-align: center;"> Nombre Solicitante </th>
                            <th style="text-align: center;"> Tipo Solicitud</th>
                            <th style="text-align: center;"> Monto Solicitado </th>
                            <th style="text-align: center;"> Cantidad de Cuotas </th>
                            <th style="text-align: center;"> Fecha Ingreso </th>
                            <th style="text-align: center;"> Fecha Modificación </th>
                            <th style="text-align: center;"> Región </th>
                            <th style="text-align: center;"> Ejecutivo </th>
                            <th style="text-align: center;"> Estado </th>


                            <th style="text-align: center;">Asignar</th>
                        </tr>

                    </thead>

                    <tbody>
                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let pos of postulaciones | paginate: config; let i = index">
                            <td style="text-align: center;" *ngIf="pos.estado != 'PENDIENTE'">
                                <mat-checkbox [(ngModel)]="pos.seleccionado" color="primary" (ngModelChange)="updateAllComplete()"> </mat-checkbox>
                            </td>
                            <td style="text-align: center;" *ngIf="pos.estado == 'PENDIENTE'">

                            </td>
                            <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialog(pos.id, pos.producto, false,false)">{{pos.id}}</a></td>
                            <td style="text-align: center;"> <a (click)="detalleBeneficiario(pos.rut)" style="cursor:pointer; text-decoration: underline;"> {{pos.rut}} </a> </td>
                            <td style="text-align: center;">{{pos.nombreCompleto}}</td>
                            <td style="text-align: center;">{{pos.nombreProducto}}</td>
                            <td style="text-align: center;">{{pos.montoSolicitado}}</td>
                            <td style="text-align: center;">{{pos.idCantidadCuotas}}</td>
                            <td style="text-align: center;">{{pos.fechaCreacion}}</td>
                            <td style="text-align: center;">{{pos.fechaModificacion}}</td>
                            <td style="text-align: center;">{{pos.nombreRegion}}</td>
                            <td style="text-align: center;">{{pos.nombreEjecutivo}}</td>
                            <td style="text-align: center;" *ngIf="pos.estado == 'RECHAZADA'"> <a (click)="detalleRechazoBeneficiario(pos.id)" style="cursor:pointer; text-decoration: underline;">{{pos.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="pos.estado == 'PAGADA'"> <a (click)="detalleSolicitudPagada(pos.id)" style="cursor:pointer; text-decoration: underline;">{{pos.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="pos.estado == 'CERRADA PAGADA'"> <a (click)="detalleSolicitudPagada(pos.id)" style="cursor:pointer; text-decoration: underline;">{{pos.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="pos.estado != 'RECHAZADA' && pos.estado != 'PAGADA' && pos.estado != 'CERRADA PAGADA'"> {{pos.estado}}</td>
                          

                            <td style="text-align: center;">
                                <button *ngIf="tipoPostulacion == 'Asignadas' && pos.estado == 'EN VALIDACION' " class="btn btn-success" (click)="openEditDialog(pos.id, pos.producto, true,false)" style="width: 120px">

                                <i class = "fa fa-pen"> </i> Gestionar 

                            </button>
                                <button *ngIf="tipoPostulacion == 'Asignadas' && pos.estado != 'EN VALIDACION'" class="btn btn-warning" (click)="openEditDialog(pos.id, pos.producto, false,false )" style="width: 120px">

                                <i class = "fa fa-pen"> </i> Revisar
                               
                            </button>
                            <div *ngIf="this.rol != 'ROLE_EJECUTIVO_CAIP'">                         
                            <button *ngIf=" (tipoPostulacion == 'Disponibles' && pos.estado != 'PAGADA' && pos.estado != 'ANULADA' && pos.estado != 'RECHAZADA' && pos.estado !='PENDIENTE'
                              
                                && ((this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_ENCARGADO_CONTABILIDAD' || this.rol == 'ROLE_ENCARGADO_REGIONAL' || this.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE') && tipoPostulacion == 'Disponibles' && pos.estado != 'PAGADA' && pos.estado !='PENDIENTE')
                                || ((pos.estado == 'EN VALIDACION' || pos.estado == 'INGRESADA') && tipoPostulacion == 'Disponibles' && (this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ASISTENTE_SOCIAL')) 
                                || (pos.estado == 'RECHAZADA' && tipoPostulacion == 'Disponibles' && this.rol == 'ROLE_ADMINISTRADOR'))
                                || (pos.estado == 'DISPONIBLE PARA PAGO'  && tipoPostulacion == 'Disponibles' && (this.rol == 'ROLE_ADMINISTRADOR'))
                                && (idUsuario!=pos.idEjecutivoAsignado && tipoPostulacion == 'Disponibles')
                                ;else noAsigna
                                " class="btn btn-warning" style="width: 120px" (click)="asignaPostulacion(pos.id)">
                                

                                    <i class = "fa fa-pen"> </i> Asignar

                                </button>
                                </div>
                                <ng-template #noAsigna>
                                    <button *ngIf="tipoPostulacion == 'Disponibles'" class="btn btn-secondary" style="width: 120px" disabled>
                               Sin acciones
                              </button>
                                </ng-template>

                            </td>



                        </tr>
                    </tbody>
                </table><br/>
                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>
            </div>
        </div>
    </div>

    <div class="afiliado" *ngIf="rol != 'ROLE_AFILIADO' && this.solicitud =='codeudor' ">


        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-4">
                    <h1> Solicitud de Préstamos {{tipoPostulacion}} </h1>
                </div>

                <div class="col-lg-2"> </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Asignadas'">

                    <button class="btn btn-info" (click)="postulacionesDisponiblesBuscador()"> Solicitudes Disponibles </button>

                </div>

                <div class="col-lg-3" *ngIf="tipoPostulacion == 'Disponibles'">

                    <button class="btn btn-info" (click)="postulacionesAsignadas()"> Solicitudes Asignadas </button>

                </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                    <select class="form-control" (change)="buscar()" [(ngModel)]="buscador.itemsPerPage">
                    
                                            <option value = "5">5</option>
                                            <option value = "10">10</option>
                                            <option value = "20">20</option>
                                            <option value = "30">30</option>
                                            <option value = "50">50</option>
                    
                    </select> </div>

            </div>
            <hr/> <br/>

            <div>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> RUT de Usuario: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="rut" class="form-control" type="text" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>
                    <div class="col-lg-2" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL'">
                        <h3> Región: </h3>
                    </div>

                    <div class="col-lg-3" *ngIf="this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL'">

                        <mat-select [(ngModel)]="buscador.region" [disabled]="this.rol != 'ROLE_ADMINISTRADOR' && this.rol != 'ROLE_ENCARGADO_NACIONAL'">

                            <mat-option value="0">

                                SELECCIONE....

                            </mat-option>

                            <mat-option *ngFor="let region of regiones" value="{{region.id}}">

                                {{region.nombre}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>

                <div class="row">

                    <div class="col-lg-2">
                        <h3> ID Solicitud: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input class="form-control" type="number" pattern="[0-9]" [(ngModel)]="buscador.idSolicitud" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Estados: </h3>
                    </div>

                    <div class="col-lg-3">

                        <mat-select [(ngModel)]="buscador.estadoselect" multiple>

                            <mat-option *ngFor="let esta of estado" value="{{esta}}">

                                {{esta}}

                            </mat-option>

                        </mat-select>
                    </div>

                    <div class="col-lg-2"> </div>

                </div> <br/>


                <div class="row">

                    <div class="col-lg-2">
                        <h3> Fecha Inicio: </h3>
                    </div>

                    <div class="col-lg-3">

                        <input name="fechaInicio" class="form-control" type="date" placeholder="Ingrese la fecha Inicio" />

                    </div>

                    <div class="col-lg-2">
                        <h3> Fecha Fin: </h3>
                    </div>

                    <div class="col-lg-3">
                        <input name="fechaFin" class="form-control" type="date" placeholder="Ingrese la fecha Fin" />
                    </div>

                    <div class="col-lg-2"> <button class="btn btn-info">
                        <i class = "fa fa-search"></i> Buscar </button>

                    </div>

                </div>
                <hr/> <br/>

                <div class="row" *ngIf="tipoPostulacion == 'Disponibles' && this.solicitud != 'codeudor'">

                    <div class="col-lg-2">
                        <h3>
                            <mat-checkbox color="primary"> Seleccionar Todo </mat-checkbox>
                        </h3>
                    </div>
                    <div *ngIf="this.rol != 'ROLE_EJECUTIVO_CAIP'">
                        <div class="col-lg-2"> <button mat-button class="mat-raised-button btn-warning" (click)="asignarSeleccionados()">
                    
                              <i class = "fa fa-pen"></i> Asignar Seleccionados </button>
                        </div>
                    </div>
                    <div class="col-lg-10"> </div>
                    <!-- <div class="col-lg-2"><button class="mat-raised-button btn-success" (click)="cargaSolicitudesDisponibles()">
                        Ver Solicitudes Disponibles</button></div>
-->
                </div>
                <!--  <div class="row" *ngIf="tipoPostulacion == 'Asignadas'">
                    <div class="col-lg-9">
                        <h1> </h1>
                    </div>
                    <div class="col-lg-2">

                        <div class="col-lg-2">
                            <button class="mat-raised-button btn-success" (click)="postulacionesAsignadas()"> Solicitudes Asignadas </button>
                        </div>

                    </div><br/>

                </div>
                <div class="row">
                    <div class="col-lg-9">
                        <h1> </h1>
                    </div>
                    <div class="col-lg-2">

                    </div>
                </div>-->
                <br/>
                <div class="table-responsive">

                    <table class="table" style="border: 1px;">

                        <thead style="background-color: #0f69b4;color:white;">

                            <tr>
                                <th style="text-align: center;"> N° </th>
                                <th style="text-align: center;"> RUT Solicitante</th>
                                <th style="text-align: center;"> Nombre Solicitante</th>
                                <th style="text-align: center;"> Fecha Ingreso </th>
                                <th style="text-align: center;"> Tipo Préstamo </th>
                                <th style="text-align: center;"> Monto Solicitado </th>
                                <th style="text-align: center;"> Cantidad de Cuotas </th>
                                <th style="text-align: center;"> Fecha Primer Descuento</th>
                                <th style="text-align: center;"> Estado </th>

                                <th style="text-align: center;"> Ver Archivo(s) </th>
                                <th style="text-align: center;"> Revisar</th>

                            </tr>

                        </thead>

                        <tbody>
                            <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let pre of prestamos | paginate: config; let i = index">
                                <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialog(pre.idPostulacion, 4, false,false)">{{pre.idPostulacion}}</a></td>

                                <td style="text-align: center;"><a (click)="detalleBeneficiario(pre.rutUsuario)" style="cursor:pointer; text-decoration: underline;"> {{pre.rutUsuario}} </a> </td>
                                <td style="text-align: center;">{{pre.nombreUsuario}} {{pre.apellidoUsuario}}</td>
                                <td style="text-align: center;">{{pre.fechaIngreso}}</td>
                                <td style="text-align: center;">{{pre.tipoPrestamoString}}</td>
                                <td style="text-align: center;">{{pre.montoSolicitado}}</td>
                                <td style="text-align: center;">{{pre.idCantidadCuota}}</td>
                                <td style="text-align: center;">{{pre.fechaPrimerPago}}</td>
                                <td style="text-align: center;" *ngIf="pre.estado == 'RECHAZADA'"> <a (click)="detalleRechazoBeneficiario(pre.idPostulacion)" style="cursor:pointer; text-decoration: underline;">{{pre.estado}} </a></td>
                                <td style="text-align: center;" *ngIf="pre.estado == 'CERRADA PAGADA'"> <a (click)="detalleSolicitudPagada(pre.idPostulacion)" style="cursor:pointer; text-decoration: underline;">{{pre.estado}} </a></td>
                                <td style="text-align: center;" *ngIf="pre.estado == 'PAGADA'"> <a (click)="detalleSolicitudPagada(pre.idPostulacion)" style="cursor:pointer; text-decoration: underline;">{{pre.estado}} </a></td>
                                <td style="text-align: center;" *ngIf="pre.estado != 'RECHAZADA' && pre.estado != 'CERRADA PAGADA' && pre.estado != 'PAGADA'"> {{pre.estado}}</td>
                              

                                <td style="text-align: center;"> <button class="btn btn-info" (click)="verArchivo(pre.idPostulacion)" style="width: 120px">

                                <i class = "fa fa-search"> </i> Ver

                                     </button>
                                </td>

                                <td *ngIf="pre.estado == 'PENDIENTE' && ((pre.idCodeudorUno == idEjecutivo && pre.estadoCodeudorUno =='INGRESADA')|| (pre.idCodeudorDos == idEjecutivo && pre.estadoCodeudorDos =='INGRESADA'))">
                                    <p><button class="btn-success" (click)="openDialogCodeudorPrestamo(pre.idPostulacion,true)">
                                        <i class = "fa fa-money-bill-alt"> </i> Aceptar/Rechazar</button></p>
                                </td>
                                <td *ngIf="pre.estado != 'PENDIENTE'">
                                    <p><button class="mat-raised-button btn-warning" style="width: 120px" (click)="openDialogCodeudorPrestamo(pre.idPostulacion,false)">
                                    <i class = "fa fa-pen"> </i> Revisar</button></p>
                                </td>
                            </tr>


                        </tbody>

                    </table> <br/>
                    <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>


                </div>

            </div>
        </div>
    </div>



    <div class="container" style="height:100px"> </div>